module.exports = __webpack_public_path__ + "static/img_9847-59c493a60feaa113e19075c2762864c0.webp";